<div class="login-container">
  <div class="col-6 form-section">
    <img src="assets/png/broadfactorLogo.png" alt="Broadfactor Logo" class="logo" />
    <form [formGroup]="loginForm">
      <mat-form-field appearance="outline" class="input-outline">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Digite seu e-mail" formControlName="userName" required
          data-cy="forgot-password-email-input" />
        @if (loginForm.get('userName')?.hasError('required') &&
        loginForm.get('userName')?.touched) {
        <mat-error>O campo e-mail é obrigatório.</mat-error>
        } @if (loginForm.get('userName')?.hasError('email') &&
        loginForm.get('userName')?.dirty) {
        <mat-error>O e-mail inserido não é válido.</mat-error>
        }
      </mat-form-field>
      <button data-cy="forgot-password-send-button" mat-button type="submit" class="btn-primary"
        [disabled]="!loginForm.valid" (click)="onSubmit()">
        @if (isLoading()) {
        <mat-spinner diameter="24"></mat-spinner>
        } @else { Enviar }
      </button>
      <div class="forgot-password" data-cy="forgot-password-redirect-home-link">
        <a (click)="goToUrl()">Voltar para tela de login</a>
      </div>
    </form>

    <section class="social-media-section">
      <div class="contact-block">
        <a target="_blank" href="https://www.instagram.com/broadfactoroficial/">
          <img class="social-media" src="assets/svg/instagram.svg" alt="Instagram" />
        </a>
        <a target="_blank" href="https://www.facebook.com/broadfactoroficial">
          <img class="social-media" src="assets/svg/facebook.svg" alt="Facebook" />
        </a>
        <a target="_blank" href="https://www.linkedin.com/company/broadfactor/">
          <img class="social-media" src="assets/svg/linkedin.svg" alt="Linkedin" />
        </a>
        <a target="_blank" href="https://www.youtube.com/channel/UChxZcuH2MjPLA7ebO4VKqUA">
          <img class="social-media" src="assets/svg/youtube.svg" alt="Youtube" />
        </a>
      </div>
    </section>

    <div class="forgot-passoword-text">
      <p>
        Esqueceu a senha? Não se preocupe, preencha o campo acima com o seu
        e-mail e vamos te enviar um link para recuperar sua senha.
      </p>
    </div>
  </div>

  <figure class="col-6">
    <img class="w-100" src="assets/png/esqueciasenha.png" alt="" />
  </figure>
</div>
